export default class NullEdit {
  // eslint-disable-next-line class-methods-use-this
  payload() {
    return {};
  }
}
